import React from 'react';
import { BatchDownloadButton } from './BatchDownloadButtonRenderer';
import { ColumnHeaderCell } from '../../components/layout/WrapperDiv';

export default (props: any) => {
  const {
    column: {
      colDef: { headerName },
      actualWidth,
    },
  } = props as any;
  return (
    <div>
      <ColumnHeaderCell actualWidth={actualWidth}>
        {headerName}
      </ColumnHeaderCell>
      <BatchDownloadButton />
    </div>
  );
};
